import { render, staticRenderFns } from "./RiskTable.vue?vue&type=template&id=9389bef4&scoped=true&"
import script from "./RiskTable.vue?vue&type=script&lang=js&"
export * from "./RiskTable.vue?vue&type=script&lang=js&"
import style0 from "./RiskTable.vue?vue&type=style&index=0&id=9389bef4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9389bef4",
  null
  
)

export default component.exports